(function() {
'use strict';

angular.module('TR')
    .directive('accordionDirective', function() {
        return {
            scope: true,
            link($scope) {
                $scope.accordion = { show: false };
            }
        };
    });
})();
